function scrollToElement(id) {
    const element = document.getElementById(id);
    if (element)
    {
        //const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        //const offsetPosition = elementPosition - 300;

        //window.scrollTo({
        //    top: offsetPosition,
        //    behavior: 'smooth'
        //});

        // Focus the element after scrolling to it
        element.focus();
    }
}

window.a11y = {
    setFocusToElement: (elementId) =>
    {

        var element = document.getElementById(elementId);
        if (element)
        {
            element.focus();
        }
    },
    getClientWidth: () =>
    {
        return window.innerWidth;
    },

    registerResizeCallback: (dotNetObject) =>
    {
        window.addEventListener('resize', () =>
        {
            dotNetObject.invokeMethodAsync('OnResize', window.innerWidth);
        });
    }

}

window.registerBackButtonHandler = (dotNetHelper) =>
{
    window.addEventListener('popstate', () =>
    {
        dotNetHelper.invokeMethodAsync('OnBrowserBack');
        document.body.classList.remove('modal-open');
        document.body.style.overflow = 'auto';
        document.body.style.paddingRight = '';

        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop)
        {
            backdrop.remove();
        }
    });
};